import { render, staticRenderFns } from "./EventTabAdvanced.vue?vue&type=template&id=5d1c79f9&"
import script from "./EventTabAdvanced.vue?vue&type=script&lang=js&"
export * from "./EventTabAdvanced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports